import * as React from 'react';
import css from './horizontal-timeline.css';


export const HorizontalTimeline = ({
  children,
  baseLineColor,
  baseLineStyle,
}: {
  children: React.ReactNode;
  baseLineColor?: string;
  baseLineStyle?: 'solid' | 'dashed';
}) => {
  const customStyle: Record<string, any> = {};
  if (baseLineStyle) {
    customStyle['--baseLineStyle'] = baseLineStyle;
  }
  if (baseLineColor) {
    customStyle['--baseLineColor'] = baseLineColor;
  }

  return (
    <div className={css.timelineContainer} style={customStyle}>
      {children}
    </div>
  );
};
